import { createReducer, on } from '@ngrx/store';
import * as UsersActions from './users.actions';
import { User } from '../../shared/services/admin/users.service';

export interface UsersState {
  users: User[];
  selectedUser: User | null;
  total: number;
  page: number;
  pageSize: number;
  loading: boolean;
  error: any;
  lastFilter: {
    isActive?: boolean;
    page?: number;
    pageSize?: number;
  } | null;
}

export const initialState: UsersState = {
  users: [],
  selectedUser: null,
  total: 0,
  page: 1,
  pageSize: 20,
  loading: false,
  error: null,
  lastFilter: null,
};

export const reducer = createReducer(
  initialState,
  on(UsersActions.loadUsers, (state, { isActive, page, pageSize }) => ({
    ...state,
    loading: true,
    error: null,
    lastFilter: { isActive, page, pageSize },
  })),
  on(UsersActions.loadUsersSuccess, (state, { response }) => ({
    ...state,
    users: response.users || [],
    total: response.total || 0,
    page: response.page || 1,
    pageSize: response.page_size || 20,
    loading: false,
    error: null,
  })),
  on(UsersActions.loadUsersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(UsersActions.loadUserById, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(UsersActions.loadUserByIdSuccess, (state, { user }) => ({
    ...state,
    selectedUser: user,
    loading: false,
    error: null,
  })),
  on(UsersActions.loadUserByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(UsersActions.updateUserStatus, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(UsersActions.updateUserStatusSuccess, (state, { user }) => ({
    ...state,
    users: state.users.map((u) => (u.id === user.id ? user : u)),
    selectedUser: state.selectedUser?.id === user.id ? user : state.selectedUser,
    loading: false,
    error: null,
  })),
  on(UsersActions.updateUserStatusFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(UsersActions.clearUsers, (state) => ({
    ...state,
    users: [],
    selectedUser: null,
    total: 0,
    lastFilter: null,
  })),
);
